"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _urlParse = _interopRequireDefault(require("url-parse"));

var _queryString = _interopRequireDefault(require("query-string"));

var _classnames = _interopRequireDefault(require("classnames"));

var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function Avatar(_ref) {
  var className = _ref.className,
      _src = _ref.src,
      alt = _ref.alt,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 40 : _ref$size,
      whiteStroke = _ref.whiteStroke; // @ts-ignore

  var classes = useStyles({
    whiteStroke: whiteStroke
  });
  var strokeWidth = size === 140 ? 2 : size === 24 ? 0 : 1;
  var src = _src || '';

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      hadError = _useState2[0],
      setHadError = _useState2[1];

  var sizedSrc = function () {
    if (!src.includes('people-media') && !src.includes('profileImages')) {
      return src;
    }

    if (hadError) {
      return src;
    }

    var url = (0, _urlParse["default"])(src);
    url.set('query', _queryString["default"].stringify(_objectSpread(_objectSpread({}, _queryString["default"].parse(url.query)), {}, {
      width: size * 2,
      height: size * 2
    })));
    return url.toString();
  }();

  var handleError = function handleError() {
    setHadError(true);
  };

  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: size,
    height: size,
    role: "img",
    "aria-label": alt,
    className: (0, _classnames["default"])(classes.root, className)
  }, /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("clipPath", {
    id: "avatarMask-size-".concat(size)
  }, /*#__PURE__*/_react["default"].createElement("circle", {
    cx: size / 2,
    cy: size / 2,
    r: size / 2
  }))), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("image", {
    width: size,
    height: size,
    preserveAspectRatio: "xMinYMin slice",
    clipPath: "url(#avatarMask-size-".concat(size, ")"),
    xlinkHref: sizedSrc,
    onError: handleError
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: size / 2,
    cy: size / 2,
    r: size / 2 - strokeWidth / 2,
    strokeWidth: strokeWidth,
    className: classes.avatarStroke
  })));
}

var useStyles = (0, _makeStyles["default"])(function (theme) {
  return {
    root: {
      overflow: 'visible !important'
    },
    avatarStroke: {
      stroke: function stroke(props) {
        return props.whiteStroke ? theme.palette.common.white : theme.palette.common.black;
      },
      strokeOpacity: function strokeOpacity(props) {
        return props.whiteStroke ? theme.palette.opacity.thirtyEightPercent : theme.palette.opacity.eightPercent;
      },
      fill: 'none'
    }
  };
});
var _default = Avatar;
exports["default"] = _default;